import { required } from "vuelidate/lib/validators";  
const StrIsoIzlemKriterleriBirim = {
  data() {
    return {
      StrIsoIzlemKriterleriBirimData: {
        Kriterid: null,
        Birimid: null,
        Veri: null,
        Onay: null
      },
      FormDataType: {
        Veri: { FieldName: "Veri", Field: "combobox", FieldTitle: "Veri", ComboDataArray: [] },
        Birimid: { FieldName: "Birimid", Field: "combobox", FieldTitle: "Birim", ComboDataArray: [] },
      }
    }
  },
  validations: {
    FormData: {
      Veri: { required },
    },
    Filter:{ 
      Birimid: { required },
      Kriterid: {},
      Onay: {}, 
    }
  },
  created() {
 
 
  }
}
export default StrIsoIzlemKriterleriBirim